export const DB_NAME = "XeonDynamicWebsiteDB";
// export const DB_ID = "594c986c-f366-45fb-895a-08da2282f1ed" //local
export const DB_ID = "08da37d6-a9a0-4f45-8dfb-aa25f7d659aa" //prod